import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=71ed47bd&scoped=true&"
import script from "./ProductSelector.vue?vue&type=script&lang=js&"
export * from "./ProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductSelector.vue?vue&type=style&index=1&id=71ed47bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed47bd",
  null
  
)

export default component.exports